import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[10.5px] font-bold uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:ring-offset-1",
  {
    variants: {
      variant: {
        // Solid indigo
        default:
          "border-indigo-700 bg-indigo-600 text-white shadow-sm shadow-indigo-300/40 hover:bg-indigo-700",
        secondary:
          "border-slate-200 bg-slate-100 text-slate-700 hover:bg-slate-200",
        // Solid rose
        destructive:
          "border-rose-700 bg-rose-600 text-white shadow-sm shadow-rose-300/40 hover:bg-rose-700",
        outline:
          "border-slate-300 bg-white text-slate-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
